import {SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
  SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS,
  SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL,
  ADD_PRESCREENING_QUESTION, ADD_PRESCREENING_QUESTION_SUCCESS,ADD_PRESCREENING_QUESTION_FAIL,
  UPDATE_PRESCREENING_QUESTION, UPDATE_PRESCREENING_QUESTION_SUCCESS,UPDATE_PRESCREENING_QUESTION_FAIL,
  GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
  GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS,
  GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL
   } from "./actionTypes";
 
   const initialState = {
    loader: false,
    assessmentList: null,
    errorMessage: null,
    success: null,
    errorMsg: null,
    selectedQuestionMsg: null,
    selectederrormsg: null,
    assessmentlistloader:false,

    assessmentQuestions:null ,
    preScreeningAddQuestionSuccess: null,
    preScreeningAddQuestionFail: null,
    preScreeningUpdateQuestionSuccess: null,
    preScreeningUpdateQuestionFail: null,
    selectedPreScreeningQuestions: null,
  };
   
   

   const PrescreeningQuestionsReducer = (state = initialState, action) => {
     switch (action.type) {
           //add assessment
           case SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK:
            state = {
              ...state,
              loader: true,
              assessmentQuestions:null
            };
            break;
          case SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS:
            state = {
              ...state,
              loader: false,
              assessmentQuestions: action.payload
            };
            break;
          case SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL:
            state = {
              ...state,
              loader: false,
              assessmentQuestions: null,
            };
            break;
            //selected prescreening questions
            case GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK:
            state = {
              ...state,
              loader: true,
              selectedPreScreeningQuestions: null,
            };
            break;
            case GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS:
              state = {
                ...state,
                loader: false,
                selectedPreScreeningQuestions: action.payload,
              };
              break;
              case GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL:
              state = {
                ...state,
                loader: false,
                selectedPreScreeningQuestions: null,
              };
              break;


            // add new prescreening question
            case ADD_PRESCREENING_QUESTION:
              state = {
                ...state,
                loader: true,
                preScreeningAddQuestionSuccess: null,
                preScreeningAddQuestionFail: null  
              };
              break;
              case ADD_PRESCREENING_QUESTION_SUCCESS:
                state = {
                  ...state,
                  loader: false,
                  preScreeningAddQuestionSuccess: action.payload,
                  preScreeningAddQuestionFail: null  
                };
                break;
                case ADD_PRESCREENING_QUESTION_FAIL:
                  state = {
                    ...state,
                    loader: false,
                    preScreeningAddQuestionSuccess: null,
                    preScreeningAddQuestionFail:action.payload 
                  };
                  break;
                  case UPDATE_PRESCREENING_QUESTION:
                    state = {
                      ...state,
                      loader: true,
                      preScreeningUpdateQuestionSuccess: null,
                      preScreeningUpdateQuestionFail: null
                    };
                    break; 
                    case UPDATE_PRESCREENING_QUESTION_SUCCESS:
                      state = {
                        ...state,
                        loader: false,
                        preScreeningUpdateQuestionSuccess: action.payload,
                        preScreeningUpdateQuestionFail: null
                      };
                      break;   
                      case UPDATE_PRESCREENING_QUESTION_FAIL:
                        state = {
                          ...state,
                          loader: false,
                          preScreeningUpdateQuestionSuccess: null,
                          preScreeningUpdateQuestionFail: action.payload
                        };
                        break;   
       
  
       default:
         state = { ...state };
         break;
     }
     return state;
   };
   export default PrescreeningQuestionsReducer;
   